import { Component, OnInit} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../../services/admin.service";
import { apiUrl } from "../../../../global/global";
import { HttpParams } from "@angular/common/http";
import { Subject } from "rxjs";

@Component({
  selector: "app-subscription-plan",
  templateUrl: "./subscription-plan.component.html",
  styleUrls: ["./subscription-plan.component.css"]
})
export class SubscriptionPlanComponent implements OnInit {

  allPlans: any = [];
  allInventoryPlans: any;
  selectedID: any;
  showMe = "Choose plan";
  subscriptionObserver = new Subject<string>();
  planId:any
  constructor(private router: Router,private route: ActivatedRoute,private api: AdminService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['subscriptionId']){
      this.allPlans = params['subscriptionId']; 
      this.planId = params['subscriptionId']; 
      this.selectedID =this.planId; 
      this.getPlans()
    }
  });
    this.getPlans();
  }

  getPlans(){
    let params = new HttpParams(); 
    params = params.append("planType", "0");
    params = params.append("isFreePlan", "0");
    this.api.getData(apiUrl._paymentPlan,params)
    .subscribe(async (res) => {
      this.allPlans = res.data.data; 
    })
  }

  highlight(plan) {
    this.selectedID = plan.id; 
    // this.getInventoryPlans()
      this.router.navigateByUrl(`/account-settings/checkout/subscription/${this.selectedID}`);
  }
  getRowClass(plan): string {
    return this.selectedID && this.selectedID === plan.id ? "selected" : "";
  }

  getInventoryPlans(){
    let params = new HttpParams(); 
    params = params.append("id", this.selectedID);
    this.api.getDetail(apiUrl._paymentPlanDetail+"/"+this.selectedID,"")
    .subscribe(async (res) => {
      this.allInventoryPlans = res.data; 
    })
  }

}
